import { Pipe, PipeTransform } from '@angular/core';

declare var moment: any;

@Pipe({ name: 'timestampToDate' })
export class TimestampPipe implements PipeTransform {

    constructor() { }

    transform(timestamp: number): string {
        return moment(new Date(timestamp * 1000)).format('D MMM YYYY');
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/timestamp-to-date.pipe.ts